import { QRScanner } from '../scanner.js';

let activeScanner = null;

export function renderScannerView(container, param, syncManager) {
  container.innerHTML = `
    <!-- Compact Header (Back + Title in single line) -->
    <div class="detail-header" style="display: flex; align-items: center; gap: 0.65rem; margin-bottom: 0.65rem;">
      <button type="button" id="btn-back-scanner" class="detail-back" style="background: var(--bg-surface-dim); border: 1px solid var(--border-color); color: var(--text-main); cursor: pointer; width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; flex-shrink: 0;">
        <span class="material-symbols-outlined" style="font-size: 18px;">arrow_back</span>
      </button>
      <h2 class="section-title" style="margin: 0; font-size: 1.15rem; font-weight: 800; color: var(--text-main); line-height: 1.2;">
        Escanear NFC-e
      </h2>
    </div>

    <!-- Scanner Viewport with Overlay Controls (Reduced / Compact) -->
    <div class="scanner-viewport-wrapper" style="border-radius: 1rem; overflow: hidden; margin-bottom: 0.65rem; border: 1px solid var(--border-color); box-shadow: var(--shadow-card);">
      <div id="qr-reader" class="scanner-video-container"></div>

      <!-- Quick Camera Controls (Zoom & Torch) -->
      <div class="camera-controls-toolbar" id="camera-controls" style="position: absolute; bottom: 8px; left: 0; right: 0; display: flex; justify-content: center; align-items: center; gap: 0.5rem; z-index: 10; pointer-events: auto;">
        <button class="zoom-btn" data-zoom="1" style="background: rgba(15,23,42,0.75); border: 1px solid rgba(255,255,255,0.25); color: white; border-radius: 9999px; width: 34px; height: 34px; font-size: 0.75rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(10px); transition: all 150ms ease;">1x</button>
        <button class="zoom-btn active" data-zoom="1.8" style="background: #10B981; border: 1px solid #10B981; color: #FFFFFF; border-radius: 9999px; width: 34px; height: 34px; font-size: 0.75rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(10px); transition: all 150ms ease;">1.8x</button>
        <button class="zoom-btn" data-zoom="2.5" style="background: rgba(15,23,42,0.75); border: 1px solid rgba(255,255,255,0.25); color: white; border-radius: 9999px; width: 34px; height: 34px; font-size: 0.75rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(10px); transition: all 150ms ease;">2.5x</button>
        <button class="torch-btn" id="btn-torch" style="background: rgba(15,23,42,0.75); border: 1px solid rgba(255,255,255,0.25); color: white; border-radius: 9999px; width: 34px; height: 34px; cursor: pointer; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(10px); transition: all 150ms ease;">
          <span class="material-symbols-outlined" style="font-size: 17px;">flashlight_on</span>
        </button>
      </div>
    </div>

    <div class="chart-card mb-lg text-center" style="width: 100%; padding: 0.85rem 1rem; box-sizing: border-box; margin-bottom: 1.25rem;">
      <div style="display: flex; gap: 0.5rem; flex-wrap: wrap; margin-bottom: 0.65rem;">
        <button class="btn btn-secondary" id="btn-upload-file" style="flex: 1; min-width: 130px; display: inline-flex; align-items: center; justify-content: center; gap: 0.35rem; border-radius: var(--radius-pill); font-weight: 700; font-size: 0.82rem; padding: 0.6rem 0.85rem;">
          <span class="material-symbols-outlined" style="font-size: 17px;">photo_camera</span>
          Enviar Foto QR
        </button>
        <button class="btn btn-secondary" id="btn-manual-url" style="flex: 1; min-width: 130px; display: inline-flex; align-items: center; justify-content: center; gap: 0.35rem; border-radius: var(--radius-pill); font-weight: 700; font-size: 0.82rem; padding: 0.6rem 0.85rem;">
          <span class="material-symbols-outlined" style="font-size: 17px;">link</span>
          Colar URL
        </button>
      </div>
      <p class="text-muted" style="font-size: 0.76rem; line-height: 1.4; margin: 0;">
        Aponte a câmera para o QR Code do cupom fiscal a 20-30cm com <strong>Zoom 1.8x</strong> para leitura automática.
      </p>
      <input type="file" id="qr-file-input" accept="image/*" capture="environment" style="display: none;" />

      <!-- Inserir URL Manualmente (Full Width Modal Panel) -->
      <div id="manual-url-modal" class="hidden" style="width: 100%; margin-top: 1rem; text-align: left;">
        <div style="background: #F8FAFC; border: 1px solid var(--color-border); border-radius: 0.85rem; padding: 1rem; box-sizing: border-box; width: 100%;">
          <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.5rem;">
            <h3 style="font-size: 0.95rem; font-weight: 800; color: #111827; margin: 0; display: flex; align-items: center; gap: 0.35rem;">
              <span class="material-symbols-outlined" style="color: #2563EB; font-size: 18px;">link</span>
              Inserir URL Manualmente
            </h3>
            <button type="button" id="btn-close-modal-icon" style="background: transparent; border: none; color: #64748B; cursor: pointer; display: flex; align-items: center; padding: 0.2rem;">
              <span class="material-symbols-outlined" style="font-size: 18px;">close</span>
            </button>
          </div>

          <p class="text-muted" style="font-size: 0.78rem; margin-bottom: 0.75rem; line-height: 1.4;">
            Cole abaixo a URL completa da NFC-e copiada da câmera do celular ou leitor externo:
          </p>

          <div style="width: 100%; margin-bottom: 0.85rem;">
            <input 
              type="url" 
              id="input-url" 
              placeholder="https://www.nfce.fazenda.sp.gov.br/..." 
              style="width: 100%; box-sizing: border-box; background: #FFFFFF; border: 1px solid var(--color-border); border-radius: 0.65rem; color: #111827; padding: 0.65rem 0.85rem; font-size: 0.82rem; outline: none; font-family: var(--font-mono); display: block;" 
            />
          </div>

          <div style="display: flex; gap: 0.5rem; width: 100%;">
            <button class="btn btn-primary" id="btn-submit-url" style="flex: 1; padding: 0.6rem 0.85rem; font-weight: 700; font-size: 0.82rem; display: flex; align-items: center; justify-content: center; gap: 0.3rem; border-radius: var(--radius-pill);">
              <span class="material-symbols-outlined" style="font-size: 16px;">download_done</span>
              Processar Nota
            </button>
            <button class="btn btn-secondary" id="btn-cancel-url" style="padding: 0.6rem 0.85rem; font-size: 0.82rem; border-radius: var(--radius-pill); font-weight: 700;">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  const btnManual = container.querySelector('#btn-manual-url');
  const btnUpload = container.querySelector('#btn-upload-file');
  const fileInput = container.querySelector('#qr-file-input');
  const modal = container.querySelector('#manual-url-modal');
  const btnSubmit = container.querySelector('#btn-submit-url');
  const btnCancel = container.querySelector('#btn-cancel-url');
  const inputUrl = container.querySelector('#input-url');
  const btnTorch = container.querySelector('#btn-torch');
  const zoomButtons = container.querySelectorAll('.zoom-btn');

  // Zoom control
  zoomButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const zoomVal = parseFloat(btn.getAttribute('data-zoom'));
      if (activeScanner) {
        activeScanner.setZoom(zoomVal);
        zoomButtons.forEach(b => {
          b.classList.remove('active');
          b.style.background = 'rgba(0,0,0,0.7)';
          b.style.borderColor = 'rgba(255,255,255,0.25)';
          b.style.color = 'white';
        });
        btn.classList.add('active');
        btn.style.background = 'var(--color-primary)';
        btn.style.borderColor = 'var(--color-primary)';
        btn.style.color = '#003824';
      }
    });
  });

  // Torch control
  btnTorch.addEventListener('click', async () => {
    if (activeScanner) {
      const isOn = await activeScanner.toggleTorch();
      if (isOn) {
        btnTorch.style.background = '#F59E0B';
        btnTorch.style.borderColor = '#F59E0B';
        btnTorch.style.color = '#000';
      } else {
        btnTorch.style.background = 'rgba(0,0,0,0.7)';
        btnTorch.style.borderColor = 'rgba(255,255,255,0.25)';
        btnTorch.style.color = 'white';
      }
    }
  });

  btnManual.addEventListener('click', () => {
    modal.classList.remove('hidden');
    inputUrl.focus();
  });

  const btnCloseIcon = container.querySelector('#btn-close-modal-icon');
  if (btnCloseIcon) {
    btnCloseIcon.addEventListener('click', () => {
      modal.classList.add('hidden');
    });
  }

  btnCancel.addEventListener('click', () => {
    modal.classList.add('hidden');
  });

  btnUpload.addEventListener('click', () => {
    fileInput.click();
  });

  fileInput.addEventListener('change', async (e) => {
    const file = e.target.files?.[0];
    if (file && activeScanner) {
      try {
        syncManager.showToast('Processando foto do cupom fiscal...', 'info');
        const url = await activeScanner.scanFile(file);
        if (url) {
          processUrl(url);
        } else {
          syncManager.showToast('Nenhum QR Code reconhecido na imagem.', 'warning');
        }
      } catch (err) {
        console.warn('File QR scan error:', err);
        syncManager.showToast('Não foi possível reconhecer o QR Code na imagem.', 'warning');
      }
    }
  });

  // Back button returns to origin hash
  const btnBackScanner = container.querySelector('#btn-back-scanner');
  if (btnBackScanner) {
    btnBackScanner.addEventListener('click', () => {
      const origin = sessionStorage.getItem('scanner_origin_hash') || localStorage.getItem('scanner_origin_hash') || '#notas';
      window.location.hash = origin;
    });
  }

  const processUrl = async (url) => {
    if (!url) return;
    try {
      syncManager.showToast('Processando cupom fiscal...', 'info');
      const nota = await syncManager.parseAndSyncNFCe(url);
      if (nota) {
        const origin = sessionStorage.getItem('scanner_origin_hash') || localStorage.getItem('scanner_origin_hash') || '#notas';
        if (origin === '#notas') {
          syncManager.showToast('Nota fiscal importada com sucesso!', 'success');
          window.location.hash = '#notas';
        } else {
          window.location.hash = `#nota/${nota.id || ''}`;
        }
      }
    } catch (err) {
      syncManager.showToast(err.message || 'Falha ao processar nota', 'error');
    }
  };

  btnSubmit.addEventListener('click', () => {
    const url = inputUrl.value.trim();
    if (url) {
      modal.classList.add('hidden');
      processUrl(url);
    }
  });

  // Init Scanner with Auto-Recovery & Visual Retry
  const startCamera = () => {
    if (activeScanner) {
      activeScanner.stop();
    }

    activeScanner = new QRScanner('qr-reader', (decodedText) => {
      processUrl(decodedText);
    });

    activeScanner.start().then(() => {
      const retryOverlay = container.querySelector('#qr-retry-overlay');
      if (retryOverlay) retryOverlay.remove();
    }).catch((err) => {
      console.warn('Camera access error:', err);
      const viewport = container.querySelector('.scanner-viewport-wrapper');
      if (viewport && !container.querySelector('#qr-retry-overlay')) {
        const retryDiv = document.createElement('div');
        retryDiv.id = 'qr-retry-overlay';
        retryDiv.style.cssText = 'position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; background: rgba(15, 23, 42, 0.88); backdrop-filter: blur(8px); color: #fff; z-index: 20; padding: 1.5rem; text-align: center;';
        retryDiv.innerHTML = `
          <span class="material-symbols-outlined" style="font-size: 44px; color: #F59E0B; margin-bottom: 0.75rem;">videocam_off</span>
          <p style="margin: 0 0 0.4rem 0; font-size: 0.95rem; font-weight: 800;">Câmera em Pausa</p>
          <p style="margin: 0 0 1.1rem 0; font-size: 0.8rem; color: #CBD5E1; max-width: 240px; line-height: 1.4;">Toque abaixo para religar a câmera ou envie a foto do QR Code.</p>
          <button type="button" class="btn btn-primary" style="padding: 0.65rem 1.35rem; font-size: 0.88rem; border-radius: var(--radius-pill); font-weight: 800; display: flex; align-items: center; gap: 0.4rem; cursor: pointer;">
            <span class="material-symbols-outlined" style="font-size: 20px;">refresh</span>
            Reativar Câmera
          </button>
        `;
        retryDiv.querySelector('button').addEventListener('click', () => {
          retryDiv.remove();
          startCamera();
        });
        viewport.appendChild(retryDiv);
      }
      syncManager.showToast('Câmera indisponível. Toque em Reativar ou envie a foto.', 'info');
    });
  };

  // Auto-recovery when app returns to foreground
  const handleForegroundResume = () => {
    if (!document.hidden && window.location.hash.startsWith('#scanner')) {
      setTimeout(() => {
        startCamera();
      }, 250);
    }
  };
  document.addEventListener('visibilitychange', handleForegroundResume);

  startCamera();
}

export function stopActiveScanner() {
  if (activeScanner) {
    activeScanner.stop();
    activeScanner = null;
  }
}
